module.exports = __webpack_public_path__ + "static/img/test-bg.25939a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/test-bg.png
// module id = N+3M
// module chunks = 96